<template>
  <div class="bottom-toolbar">
    <!-- <Dropdown v-if="hasNavigation" showClear :placeholder="navigationTitle" optionLabel="Name" v-model="navigationDropdown" :options="navigationFilters" />
    <Dropdown v-if="hasViewTemplates" showClear :placeholder="viewTemplatesTitle" optionLabel="Name" v-model="viewTemplatesDropdown" :options="viewTemplatesDefinitions" /> -->
    <ButtonGroup class="flex">
      <Button v-tooltip.top="'Fit zoom'" icon="pi pi-search" severity="secondary" :disabled="!getJson" @click="fitZoom" />
      <Button v-tooltip.top="'Deselect'" icon="pi pi-times" severity="secondary" :disabled="isDeselectDisabled" @click="changeSelected([])" />
    </ButtonGroup>
  </div>
</template>

<script>
import Button from 'primevue/button';
import ButtonGroup from 'primevue/buttongroup';
import { mapGetters, mapState } from 'vuex';
import { mapActions } from 'vuex/dist/vuex.cjs.js';
import { eventBus, Events } from "@/eventBus";

export default {
  name: "BottomToolbar",
  components: {
    Button,
    ButtonGroup,
  },

  computed: {
    ...mapGetters('general', ["getJson", "getSelectedElements"]),
    ...mapState('general', ['selectedNavigationFilter', 'selectedViewTemplate']),
    ...mapState('settings', ['navigationConfig', 'viewTemplatesConfig']),
    
    navigationDropdown: {
      get() {
        return this.selectedNavigationFilter;
      }
      ,
      set(value) {
        this.changeSelectedNavigationFilter(value);
      }
    },

    viewTemplatesDropdown: {
      get() {
        return this.selectedViewTemplate;
      }
      ,
      set(value) {
        this.changeSelectedViewTemplate(value);
      }
    },

    isDeselectDisabled() {
      return !this.getJson || this.getSelectedElements.length == 0;
    },

    hasNavigation() {
      if (this.navigationConfig && this.navigationConfig.Filters && this.navigationConfig.Filters.length > 0) {
        return true;
      }
      return false;
    },

    navigationTitle() {
      return this.navigationConfig.Name || "Navigation";
    },

    navigationFilters() {
      return this.navigationConfig.Filters || [];
    },

    hasViewTemplates() {
      if (this.viewTemplatesConfig && this.viewTemplatesConfig.Definitions && this.viewTemplatesConfig.Definitions.length > 0) {
        return true;
      }
      return false;
    },

    viewTemplatesTitle() {
      return this.viewTemplatesConfig.Name || "View Templates";
    },

    viewTemplatesDefinitions() {
      return this.viewTemplatesConfig.Definitions || [];
    },
  },

  methods: {
    ...mapActions("general", ["changeSelected", "changeSelectedNavigationFilter", "changeSelectedViewTemplate"]),
    ...mapActions("view3D", ["resetDefaultCameraPosition"]),

    fitZoom() {
      this.resetDefaultCameraPosition();
      eventBus.emit(Events.ZOOM_EXTENTS);
    }
  }
};
</script>

<style scoped>
.bottom-toolbar {
  position: absolute;
  bottom: 15px;
  left: 50%;
  border-radius: 10px;
  transform: translateX(-50%);

  display: flex;
}
</style>